import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PathSelectorComponent } from './path-selector.component';
import { LayoutRowModule } from '../../../directives/layout-row/layout-row.module';
import { FlexModule } from '../../../directives/flex/flex.module';
import { OneTimeModule } from '../../../directives/one-time/one-time.module';
import { MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';


@NgModule({
    declarations: [PathSelectorComponent],
    imports: [
        CommonModule,
        LayoutRowModule,
        FlexModule,
        OneTimeModule,
        MatTreeModule,
        MatIconModule,
        MatRippleModule,
        MatButtonModule
    ],
    exports: [
        PathSelectorComponent
    ]
})
export class PathSelectorModule {
}
